import { render, staticRenderFns } from "./TypeForm.vue?vue&type=template&id=b7bef024&scoped=true"
import script from "./TypeForm.vue?vue&type=script&lang=ts"
export * from "./TypeForm.vue?vue&type=script&lang=ts"
import style0 from "./TypeForm.vue?vue&type=style&index=0&id=b7bef024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bef024",
  null
  
)

export default component.exports